module.exports = __webpack_public_path__ + "assets/1174d25a63b9343e264b216b1f128c42.svg";